type NavbarProps = {
  onLogout: () => void;
};

function Navbar({ onLogout }: NavbarProps) {
  return (
    <header className="border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[96rem] items-center justify-between px-6 py-4">
        <div className="pl-1">
          <img src="/logo-rcare.png" alt="Rheumatology Care of Georgia" className="h-12 w-auto" />
        </div>
        <button
          type="button"
          onClick={onLogout}
          className="rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-indigo-300 hover:text-indigo-700"
        >
          Logout
        </button>
      </div>
    </header>
  );
}

export default Navbar;
